import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
//import FormDataWithToken from './FormDataWithToken'
import { lazyContent } from '../main'

import 'swiper/css';
import 'swiper/css/pagination';
//import { SwiperOptions } from 'swiper/types';
import { numberformatter } from './formatters';

export default class Cars4SalePage {
    static filtersForm = document.getElementById('filters-form') as HTMLFormElement
    static totalCountEls = document.querySelectorAll('.total-count')
    static isFavoritePage = window.location.search.indexOf('ShowFavorites=true') > -1
    static isDesktop = window.innerWidth > 768
    static loading = false
    //static swiperCarsOptions: SwiperOptions = {
    //    modules: [Navigation, Pagination, Manipulation],
    //    slidesPerView: 1,
    //    centeredSlides: true,
    //    loop: false,
    //    spaceBetween: 30,
    //    init: false,
    //    autoHeight: true,
    //    updateOnWindowResize: true,
    //    slideToClickedSlide: true,
    //    breakpoints: {
    //        768: {
    //            autoHeight: false,
    //            slidesPerView: 2,
    //            spaceBetween: 10,
    //        },
    //        1024: {
    //            autoHeight: false,
    //            slidesPerView: 3,
    //            spaceBetween: 0,
    //        },
    //        1199: {
    //            autoHeight: false,
    //            slidesPerView: 3.5,
    //            spaceBetween: 0,
    //        },
    //        1399: {
    //            autoHeight: false,
    //            slidesPerView: 4,
    //            spaceBetween: 0,
    //        },
    //    },
    //    navigation: {
    //        nextEl: '.js-hero-swiper .swiper-button-next',
    //        prevEl: '.js-hero-swiper .swiper-button-prev',
    //    },
    //    on: {
    //        slideChange: function (swiper: Swiper) {
    //            Cars4SalePage.calculateSliderSlidesTransform(swiper);
    //            Cars4SalePage.activeFavouriteButton(swiper);

    //            let activeSlide = document.querySelector('.js-car-item.swiper-slide-active')
    //            let invId = activeSlide?.getAttribute('data-inventoryvehicleid')
    //            let isFavorite = activeSlide?.querySelector('.js-car-wrapper')?.classList.contains('is-favourite')
    //            const data = new FormDataWithToken()
    //            data.append('inventoryVehicleId', invId ?? '')
    //            data.append('like', 'false')

    //            // Save the skip if it is not a favorite
    //            if (isFavorite === false)
    //                fetch('?handler=SaveLikeDislike', { method: 'post', body: data })

    //            // Load More Items
    //            if (Cars4SalePage.loading === false && Cars4SalePage.isFavoritePage === false && swiper.realIndex >= (swiper.slides.length - 7)) {
    //                Cars4SalePage.loadMoreCars()
    //            }
    //        },
    //        init: function (swiper: Swiper) {
    //            setTimeout(function () {
    //                swiper.el.classList.add('is-initialized');

    //                Cars4SalePage.calculateSliderSlidesTransform(swiper);

    //                Cars4SalePage.activeFavouriteButton(swiper);
    //            }, 300);
    //        },
    //        resize: function (swiper: Swiper) {
    //            Cars4SalePage.calculateSliderSlidesTransform(swiper);
    //        },
    //        destroy: function (swiper: Swiper) {
    //            swiper.el.classList.remove('is-initialized');
    //        },
    //        touchStart: function (swiper: Swiper, event: TouchEvent | MouseEvent | PointerEvent) {
    //            const target = event.target as HTMLElement;

    //            if (target.closest('.swiper-slide')?.classList.contains('js-car-image')) {
    //                swiper.allowTouchMove = false;

    //                return;
    //            }

    //            swiper.allowTouchMove = true;
    //        }
    //    }
    //}

    //static swiperCars = new Swiper('.js-swiper-cars', this.swiperCarsOptions);
    static carsWrapper = document.getElementById('loadcars')
    static gridToggleButtons = document.querySelectorAll('.js-toggle-grid-view') as NodeListOf<HTMLElement>

    static loadingMoreEl = document.getElementById('loading-more-div');
    static loadingMoreSubEl = document.getElementById('loading-more-subdiv')

    observer = new IntersectionObserver(this.handleVisibilityChange, {
        root: null, // observing changes to visibility in the viewport
        rootMargin: '750px',
        threshold: 0
    });

    static swiperImageOptions = {
        slidesPerView: 1,
        modules: [Navigation, Pagination],
        loop: true,
        spaceBetween: 10,
        pagination: {
            el: '.js-swiper-images .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: ".sbn",
            prevEl: ".sbp",
        }
    }

    static swiperImages = new Swiper(".js-swiper-images", this.swiperImageOptions);

    constructor() {
        // Toggle Grid View
        if (Cars4SalePage.gridToggleButtons) {
            Cars4SalePage.gridToggleButtons.forEach(m => m.onclick = (event) => {
                event.preventDefault();

                if (document.body.classList.contains('grid-view') === true) {
                    document.body.classList.remove('grid-view');
                    document.body.classList.add('list-view');
                } else {
                    document.body.classList.add('grid-view');
                    document.body.classList.remove('list-view');
                }

                const enableGrid = document.body.classList.contains('grid-view');
                localStorage.setItem('enableGrid', String(enableGrid));
            })
        }

        let enableGrid = null
        if (localStorage.getItem('enableGrid') == null)
            enableGrid = true
        else
            enableGrid = localStorage.getItem('enableGrid') === 'true'

        if (enableGrid === true) {
            document.body.classList.add('grid-view');
            document.body.classList.remove('list-view');
        } else {
            document.body.classList.remove('grid-view');
            document.body.classList.add('list-view');
        }

        // Handle loading more when it comes into view
        if (Cars4SalePage.loadingMoreSubEl && Cars4SalePage.isFavoritePage === false)
            this.observer.observe(Cars4SalePage.loadingMoreSubEl);
    }

    handleVisibilityChange(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            // Check if the target is intersecting (visible)
            if (entry.isIntersecting) {
                try {
                    Cars4SalePage.loadMoreCars()
                }
                catch (ex) { }
            }
        });
    }

    static refreshSlides(data: any) {
        //if (document.body.classList.contains('grid-view') !== true) {
        //    // Carousel View
        //    Cars4SalePage.swiperCars.removeAllSlides()
        //    data?.dataItemsHTML?.forEach((item: any) => Cars4SalePage.swiperCars.appendSlide(item))
        //    Cars4SalePage.swiperCars.update()
        //}
        //else {
        // Grid View
        let html = ''
        Cars4SalePage.carsWrapper!.innerHTML = ''
        data?.dataItemsHTML?.forEach((item: any) => html += item)
        Cars4SalePage.carsWrapper?.insertAdjacentHTML('beforeend', html)
        //}

        // Refresh Lazy Load Image handler with new images
        lazyContent.update()

        // Update Swiper
        new Swiper('.js-swiper-images', this.swiperImageOptions)

        // Update Total Count
        if (Cars4SalePage.totalCountEls)
            Cars4SalePage.totalCountEls.forEach(item => item.innerHTML = numberformatter.format(data?.totalCount ?? 0))

        // Hide loading spinner if not many results
        Cars4SalePage.loadingMoreEl?.classList.toggle('inactive', (data?.totalCount ?? 0) <= 21)
    }

    static async loadMoreCars() {
        Cars4SalePage.loading = true

        //const enableGrid = localStorage.getItem('enableGrid') === 'true';

        let parms = new FormData(Cars4SalePage.filtersForm)
        parms.append('IdCSV', this.getInventoryVehicleIdCSV()) // Prevent loading items that are already visible
        const response = await fetch('/cars-for-sale?handler=LoadPage', { method: 'POST', body: parms })
        let data = await response.json()

        //if (enableGrid) {
        let html = ''
        data.dataItemsHTML.forEach((item: string) => html += item)
        this.carsWrapper?.insertAdjacentHTML('beforeend', html)
        //}
        //else {
        //    Cars4SalePage.swiperCars.appendSlide(data.dataItemsHTML)
        //}

        lazyContent.update();

        // Update Swiper
        new Swiper('.js-swiper-images', this.swiperImageOptions)

        // Hide loading spinner if not many results
        Cars4SalePage.loadingMoreEl?.classList.toggle('inactive', data.totalCount <= 21)

        Cars4SalePage.loading = false
    }

    static getInventoryVehicleIdCSV() {
        let ids = ''

        document.querySelectorAll('.swiper-slide[data-inventoryvehicleid]')?.forEach(item => {
            ids += item.getAttribute('data-inventoryvehicleid') + ','
        })

        return ids
    }

    //static handleKeyboard() {
    //    document.addEventListener('keyup', function (event) {
    //        const currentKeyCode = event.key;

    //        if (!document.body.classList.contains('grid-view')) {
    //            switch (currentKeyCode) {
    //                case 'ArrowRight':
    //                    Cars4SalePage.swiperCars.slideNext();
    //                    break;
    //                case 'ArrowLeft':
    //                    Cars4SalePage.swiperCars.slidePrev();
    //                    break;
    //                case 'ArrowUp':
    //                    const upElements = document.querySelectorAll<HTMLElement>('.js-car-toggle-favourite-swiper');
    //                    if (upElements.length > 0) upElements[0].click();
    //                    break;
    //            }
    //        }
    //    });
    //}

    static activeFavouriteButton(swiper: Swiper) {
        if (swiper.slides[swiper.activeIndex].querySelector('.js-car-wrapper')?.classList.contains('is-favourite') === true) {
            document.querySelector('.js-car-toggle-favourite-swiper')?.classList.add('is-favourite')
        } else {
            document.querySelector('.js-car-toggle-favourite-swiper')?.classList.remove('is-favourite')
        }
    }

    static calculateSliderSlidesTransform(swiper: Swiper) {
        const activeSlideIndex = swiper.activeIndex
        const nextSlidesArray = swiper.slides.slice(activeSlideIndex);
        const prevSlidesArray = swiper.slides.slice(0, activeSlideIndex);

        //const slideWidth = $(swiper.slides[0]).outerWidth();
        //const numberOfVisibleSlides = swiper.params.slidesPerView;

        let slideScale = .6;

        if (window.outerHeight > 1249) {
            slideScale = 1 - .78;
        }

        nextSlidesArray.map(function (nextSlide, index) {
            nextSlide.classList.remove('prev-element');
            nextSlide.classList.add('next-element');

            if (nextSlide.classList.contains('next-element')) {
                nextSlide.style.transform = `translateX(-${nextSlide.clientWidth * slideScale / 2 * (index - 1)}px)`
            }
        })

        prevSlidesArray.map(function (prevSlide, index) {
            prevSlide.classList.add('prev-element');

            if (prevSlide.classList.contains('prev-element')) {
                prevSlide.style.transform = `translateX(${prevSlide.clientWidth * slideScale / 2 * (prevSlidesArray.length - index - 1)}px)`
            }
        })
    }
}

if (window.location.href.indexOf('/cars-for-sale') > -1) {
    new Cars4SalePage()
}

document.addEventListener('click', function (e: MouseEvent) {
    let el = e.target as HTMLFormElement
    let c = el.closest('.has-tooltip')

    if (c) {
        // Toggle tooltip visibility
        let tooltip = c.querySelector('.tooltip') as HTMLElement;
        tooltip.classList.toggle('hidden');
    } else {
        // Hide the tooltip if clicking outside
        document.querySelector('.tooltip')?.classList.add('hidden');
    }
});